// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ezdojqbjowcxtdjwmmqo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV6ZG9qcWJqb3djeHRkandtbXFvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkxMTM3MzMsImV4cCI6MjA1NDY4OTczM30.MU-4Wh4IE0bSJJ8kDZUqZsli28LTXIzkisVYqps68vM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);